module.exports = __webpack_public_path__ + "img/telegram-monochrome.65f14580.svg";